import { TagColor, TagColorType } from "./types";

export const TAGS_COLORS: Record<TagColor, TagColorType> = {
  orange: {
    label: "Orange",
    bgClass: "bg-orange-400 dark:bg-orange-600",
    fgClass: "text-orange-400 dark:text-orange-600",
  },
  amber: { label: "Amber", bgClass: "bg-amber-400 dark:bg-amber-600", fgClass: "text-amber-400 dark:text-amber-600" },
  lime: { label: "Lime", bgClass: "bg-lime-400 dark:bg-lime-600", fgClass: "text-lime-400 dark:text-lime-600" },
  green: { label: "Green", bgClass: "bg-green-400 dark:bg-green-600", fgClass: "text-green-400 dark:text-green-600" },
  teal: { label: "Teal", bgClass: "bg-teal-400 dark:bg-teal-600", fgClass: "text-teal-400 dark:text-teal-600" },
  cyan: { label: "Cyan", bgClass: "bg-cyan-400 dark:bg-cyan-600", fgClass: "text-cyan-400 dark:text-cyan-600" },
  blue: { label: "Blue", bgClass: "bg-blue-400 dark:bg-blue-600", fgClass: "text-blue-400 dark:text-blue-600" },
  indigo: {
    label: "Indigo",
    bgClass: "bg-indigo-400 dark:bg-indigo-600",
    fgClass: "text-indigo-400 dark:text-indigo-600",
  },
  purple: {
    label: "Purple",
    bgClass: "bg-purple-400 dark:bg-purple-600",
    fgClass: "text-purple-400 dark:text-purple-600",
  },
  pink: { label: "Pink", bgClass: "bg-pink-400 dark:bg-pink-600", fgClass: "text-pink-400 dark:text-pink-600" },
  rose: { label: "Rose", bgClass: "bg-rose-400 dark:bg-rose-600", fgClass: "text-rose-400 dark:text-rose-600" },
};

export const VALID_TAG_COLORS = Object.keys(TAGS_COLORS) as Array<TagColor>;
